import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Flag Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?type=design&node-id=769-26346&mode=dev)
 * */
const FlagIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M.844 11.703V1.391m0 7.772 1.445-.445a4.405 4.405 0 0 1 3.605.459 4.407 4.407 0 0 0 3.52.487l1.368-.392a.516.516 0 0 0 .374-.496V3.401a.515.515 0 0 0-.657-.496l-1.086.31a4.407 4.407 0 0 1-3.52-.483 4.405 4.405 0 0 0-3.604-.459l-1.445.444" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default FlagIcon;